import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '@/containers/Full';

// Views
import Dashboard from '@/views/Dashboard.vue';
// import Charts from '@/views/Charts';
// import Widgets from '@/views/Widgets';

// Views - Components

import Users from '@/views/components/identities/Users.vue';
import Permissions from '@/views/components/identities/Permissions.vue';
import Roles from '@/views/components/identities/Roles.vue';
import Clients from '@/views/components/documents/Clients.vue';
import NewContract from '@/views/components/documents/Contract.vue';
import Contracts from '@/views/components/documents/Contracts.vue';
import EditContract from '@/views/components/documents/EditContract.vue';
import EditClient from '@/views/components/documents/EditClient.vue';
import Templates from '@/views/components/documents/Templates.vue';
import NewTemplate from '@/views/components/documents/NewTemplate.vue';
import EditTemplate from '@/views/components/documents/EditTemplate.vue';
import Invoices from '@/views/components/documents/Invoices.vue';
import CashFlowPlan from '@/views/components/jira/CashFlowPlan.vue';

import WorklogsPersons from '@/views/components/jira/WorklogsPersons.vue';
import Worklogs from '@/views/components/jira/Worklogs.vue';
import ProjectWorklogs from '@/views/components/jira/ProjectWorklogs.vue';
import ProjectWorklogsCategory from '@/views/components/jira/ProjectWorklogsCategory.vue';
import UserRateForm from '@/views/components/jira/UserRateForm.vue';
import IncomingPayments from '@/views/components/jira/IncomingPayments.vue';
import Employees from '@/views/components/jira/Employees.vue';
import AuditLogs from '@/views/components/jira/AuditLogs.vue';
import Projects from '@/views/components/jira/Projects.vue';
import ProjectFinances from '@/views/components/jira/ProjectFinances.vue';
import ProjectFinancesOld from '@/views/components/jira/ProjectFinancesOld.vue';
import Project from '@/views/components/jira/Project.vue';
import SpecialBusinessDays from '@/views/components/jira/SpecialBusinessDays.vue';
import EnvEditor from '@/views/components/jira/EnvEditor.vue';
import VacationPlanner from '@/views/components/jira/VacationPlanner.vue';
import ProjectGraphics from '@/views/components/jira/ProjectGraphics.vue';
import ProjectTabGraphics from '@/views/components/jira/ProjectTabGraphics.vue';
import ProjectTabInvoicesPayments from '@/views/components/jira/ProjectTabInvoicesPayments.vue';
import ProjectsOverview from '@/views/components/jira/ProjectsOverview.vue';

// import ProjectForm from '@/views/components/jira/ProjectForm.vue';
import ProjectFormWithChangeLogsContainer from '@/views/Project/ProjectFormWithChangeLogsContainer.vue';
import ProjectHome from '@/views/Project/ProjectHome.vue';
import ProjectFinanceTable from '@/views/Project/ProjectFinanceTable.vue';

import ApplyJiraIssues from '@/views/components/jira/JiraIssues';
import ApplyJiraProjects from '@/views/components/jira/JiraProjects';
import ApplyJiraProjectIssues from '@/views/components/jira/JiraProjectIssues';

import DashMain from '@/views/components/dash/DashMain';
import DashMain2024 from '@/views/components/dash/DashMain2024';
import AllProjectGant from '@/views/components/dash/AllProjectGant';
import AllProjectWorklogs from '@/views/components/dash/AllProjectWorklogs';
import Billable from '@/views/components/dash/Billable';
import BillableTable from '@/views/components/dash/BillableTable';
import RecentWorklogsHeat from '@/views/components/dash/RecentWorklogsHeat';
import BlackWall from '@/views/components/dash/BlackWall';
import ProjectIssueForTimeStats from '@/views/components/dash/ProjectIssueForTimeStats';
import Absences from '@/views/components/dash/Absences';
import Idle from '@/views/components/dash/Idle';
import WorkLogStats from '@/views/components/dash/WorkLogStats';

import TvCodes from '@/views/TvCodes/TvCodes';
import TvCodeForm from '@/views/TvCodes/TvCodeForm';

import EmployeesNew from '@/views/Employees/Employees.vue';
import EmployeeForm from '@/views/Employees/EmployeeForm.vue';
import EmployeeHome from '@/views/Employees/EmployeeHome.vue';

import UserIssues from '@/views/reports/UserIssues';

import DeprecatedRoute from '@/views/components/misc/DeprecatedRoute';

import VacationTypesListVue from '@/views/components/vacations/VacationTypesList.vue';
import VacationTypeFormVue from '@/views/components/vacations/VacationTypeForm.vue';
import VacationsList from '@/views/components/vacations/VacationsList.vue';
import VacationRequestForm from '@/views/components/vacations/VacationRequestForm.vue';

/*
const ApplyJiraIssuesSearch = () => import('@/views/applyCustom/Jira/JiraIssuesSearch');
const ApplySettings = () => import('@/views/applyCustom/Pages/Settings');
const ApplyJiraProjectIssuesFilter = () => import('@/views/applyCustom/Jira/JiraProjectIssuesFilter');
*/

// Views - Icons
// import FontAwesome from '@/views/icons/FontAwesome';
// import SimpleLineIcons from '@/views/icons/SimpleLineIcons';

// Views - Pages
import Page404 from '@/views/pages/Page404';
import Page500 from '@/views/pages/Page500';
import Forbidden from '@/views/pages/Forbidden';
import Login from '@/views/pages/Login';
import LoginTv from '@/views/pages/LoginTv';
import Register from '@/views/pages/Register';

import PermissionsDeclaration from '../permissions/index';
// console.log(PermissionsDeclaration);
import store from '@/store';

Vue.use(Router);

const publicRoutes = [
  'Login',
  'LoginTv',
  'Page404',
  'Page500',
  // 'Register',
  // 'PasswordForgot',
  // 'PasswordReset',
];

const router = new Router({
  // mode: 'hash', // hash or hash = Demo is living in GitHub.io, so required!

  mode: 'history',

  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'forbidden',
          name: 'Forbidden',
          component: Forbidden
        },
        {
          path: 'p',
          // redirect: '/identities/users',
          name: 'ProjectsNew',
          component: {
            render(c) { return c('router-view'); }
          },
          children: [
            {
              path: ':jira_key/:cat?',
              name: 'ProjectHome',
              props: true,
              component: ProjectHome,
            },
            {
              path: ':jira_key/logs',
              name: 'ProjectFormWithChangeLogsContainer',
              props: true,
              component: ProjectFormWithChangeLogsContainer,
            },
            {
              path: ':jira_key/finances',
              name: 'ProjectFinanceTable',
              props: true,
              component: ProjectFinanceTable,
            },
          ],
        },
        {
          path: 'emp/:id_or_email/:cat?',
          name: 'EmployeeHome',
          component: EmployeeHome,
          props: true,
          // meta: {
          //   storeHist: true,
          // }
          // props: (route) => {
          //   return { id_or_email: route.params.id_or_email };
          // },
        },
        {
          path: 'employees',
          // redirect: '/identities/users',
          redirect: '/employees/list/1',
          name: 'EmployeesNew',
          component: {
            render(c) { return c('router-view'); }
          },
          children: [
            {
              path: 'list/:page?',
              name: 'EmployeesNewList',
              props: (route) => {
                return {
                  page: Number(route.params.page || 1)
                };
              },
              component: EmployeesNew,
            },
            {
              path: ':id/form',
              name: 'EmployeeForm',
              props: (route) => {
                return { id: parseInt(route.params.id, 10).toString() !== route.params.id ? route.params.id : Number(route.params.id) };
              },
              component: EmployeeForm,
            },
          ],
        },

        // {
        //   path: 'widgets',
        //   name: 'Widgets',
        //   component: Widgets
        // },
        {
          path: 'identities',
          redirect: '/identities/users',
          name: 'Identities',
          component: {
            render(c) { return c('router-view'); }
          },
          children: [
            {
              path: 'users',
              name: 'Users',
              component: Users,
            },
            {
              path: 'permissions',
              name: 'Permissions',
              component: Permissions
            },
            {
              path: 'roles',
              name: 'Roles',
              component: Roles
            },
            {
              path: 'tvcodes',
              name: 'TvCodes',
              // component: TvCodes,
              redirect: { name: 'TvCodesList', params: { page: 1 } },

              component: {
                render(c) { return c('router-view'); }
              },

              children: [
                {
                  path: 'list/:page?',
                  name: 'TvCodesList',
                  props: (route) => {
                    return {
                      page: Number(route.params.page || 1)
                    };
                  },
                  component: TvCodes,
                },
                {
                  path: 'create',
                  name: 'TvCodeCreate',
                  component: TvCodeForm
                },
                {
                  path: 'update/:id',
                  name: 'TvCodeUpdate',
                  props: (route) => {
                    return {
                      id: Number(route.params.id)
                    };
                  },
                  component: TvCodeForm
                },
              ],
            }

          ]
        },
        {
          path: 'documents',
          redirect: '/documents/contract',
          name: 'Contract',
          component: {
            render(c) { return c('router-view'); }
          },
          children: [
            {
              path: 'clients',
              name: 'Clients',
              component: Clients
            },
            {
              path: 'edit-client/:id',
              name: 'EditClient',
              component: EditClient
            },
            {
              path: 'new-contract/:id?',
              name: 'NewContract',
              component: NewContract
            },
            {
              path: 'contracts',
              name: 'Contracts',
              component: Contracts
            },
            {
              path: 'edit-contract/:id',
              name: 'EditContract',
              component: EditContract
            },
            {
              path: 'templates',
              name: 'Templates',
              component: Templates
            },
            {
              path: 'new-template',
              name: 'NewTemplate',
              component: NewTemplate
            },
            {
              path: 'edit-template/:id',
              name: 'EditTemplate',
              component: EditTemplate
            },
            {
              path: 'invoices',
              name: 'Invoices',
              component: Invoices
            },
            {
              path: 'incoming-payments',
              name: 'IncomingPayments',
              component: IncomingPayments,
            },
            {
              path: 'cash-flow-plan',
              name: 'CashFlowPlan',
              component: CashFlowPlan,
            },
          ]
        },
        {
          path: 'reports',
          redirect: '/reports/UserIssues',
          name: 'Reports',
          component: {
            render(c) { return c('router-view'); }
          },
          children: [
            {
              path: 'UserIssues',
              name: 'UserIssues',
              component: UserIssues
            },
          ],
        },
        {
          path: 'dash',
          redirect: '/dash/main',
          name: 'Dash',
          component: {
            render(c) { return c('router-view'); }
          },
          children: [
            {
              path: 'main',
              name: 'DashMain',
              component: DashMain
            },
            {
              path: 'main2024',
              name: 'DashMain2024',
              component: DashMain2024
            },
            {
              path: 'project/:id_or_key',
              name: 'DashProject',
              component: DeprecatedRoute,
              props: (route) => {
                return {
                  url: '/p/:id_or_key/epics',
                  params: {
                    id_or_key: route.params.id_or_key,
                  }
                };
              },
            },

            {
              path: 'allprojectgant',
              name: 'AllProjectGant',
              component: AllProjectGant
            },
            {
              path: 'BlackWall',
              name: 'BlackWall',
              component: BlackWall
            },
            {
              path: 'allprojectworklogs',
              name: 'AllProjectWorklogs',
              component: AllProjectWorklogs
            },
            {
              path: 'ProjectIssueForTimeStats',
              name: 'ProjectIssueForTimeStats',
              component: ProjectIssueForTimeStats
            },
            {
              path: 'absences',
              name: 'Absences',
              component: Absences
            },
            {
              path: 'idle',
              name: 'Idle',
              component: Idle
            },
            {
              path: 'WorkLogStats',
              name: 'WorkLogStats',
              component: WorkLogStats,
              props: () => {
                return {
                  showAll: true
                };
              },
            },
            {
              path: 'billable',
              name: 'Billable',
              component: Billable
            },
            {
              path: 'billable-table',
              name: 'BillableTable',
              component: BillableTable
            },
            {
              path: 'RecentWorklogsHeat',
              name: 'RecentWorklogsHeat',
              component: RecentWorklogsHeat
            },
          ]
        },
        {
          path: 'vacations',
          redirect: '/vacations/types/1',
          name: 'Vacations',
          component: {
            render(c) { return c('router-view'); }
          },
          children: [
            {
              path: 'list/:page?',
              name: 'VacationsList',
              props: (route) => {
                return {
                  page: Number(route.params.page || 1)
                };
              },
              component: VacationsList
            },
            {
              path: 'create',
              name: 'VacationCreate',
              component: VacationRequestForm
            },
            {
              path: 'update/:id',
              name: 'VacationUpdate',
              props: (route) => {
                return {
                  id: Number(route.params.id)
                };
              },
              component: VacationRequestForm
            },
            {
              path: 'types/:page?',
              name: 'VacationTypesList',
              props: (route) => {
                return {
                  page: Number(route.params.page || 1)
                };
              },
              component: VacationTypesListVue
            },
            {
              path: 'vacation-type-create',
              name: 'VacationTypeCreate',
              component: VacationTypeFormVue
            },
            {
              path: 'vacation-type-update/:id',
              name: 'VacationTypeUpdate',
              props: (route) => {
                return {
                  id: Number(route.params.id)
                };
              },
              component: VacationTypeFormVue
            },
          ],
        },
        {
          path: 'jira',
          redirect: '/jira/worklogs',
          name: 'Jira',
          component: {
            render(c) { return c('router-view'); }
          },
          children: [
            {
              path: 'worklogs',
              name: 'Worklogs',
              component: Worklogs
            },
            {
              path: 'worklogs-persons',
              name: 'WorklogsPersons',
              component: WorklogsPersons
            },
            {
              path: 'project-worklogs',
              name: 'ProjectWorklogs',
              component: ProjectWorklogs
            },
            {
              path: 'project-worklogs-category',
              name: 'ProjectWorklogsCategory',
              component: ProjectWorklogsCategory
            },
            {
              path: 'project-graphics',
              name: 'ProjectGraphics',
              component: ProjectGraphics
            },
            {
              path: 'new-user-rate',
              name: 'UserRateForm',
              component: UserRateForm,
            },
            {
              path: 'employees',
              name: 'Employees',
              component: Employees,
            },
            {
              path: 'audit-logs',
              name: 'AuditLogs',
              component: AuditLogs,
            },
            {
              path: 'projects',
              name: 'Projects',
              component: Projects,
            },
            {
              path: 'project-finances',
              name: 'ProjectFinances',
              component: ProjectFinances,
            },
            {
              path: 'project-finances-old',
              name: 'ProjectFinancesOld',
              component: ProjectFinancesOld,
            },
            {
              path: 'project/:id',
              name: 'Project',
              component: Project,
            },
            {
              path: 'special-days',
              name: 'SpecialBusinessDays',
              component: SpecialBusinessDays,
            },
            {
              path: 'enveditor',
              name: 'EnvEditor',
              component: EnvEditor,
            },
            {
              path: 'planned-vacations',
              name: 'VacationPlanner',
              component: VacationPlanner,
            },
            {
              path: 'project-tab-planning/:id',
              name: 'ProjectTabPlanning',
              component: DeprecatedRoute,
            },
            {
              path: 'project-tab-graphics/:id',
              name: 'ProjectTabGraphics',
              component: ProjectTabGraphics,
              props: (route) => {
                return {
                  id: Number(route.params.id),
                };
              },
            },
            {
              path: 'project-tab-invoices-payments/:id',
              name: 'ProjectTabInvoicesPayments',
              component: ProjectTabInvoicesPayments,
              props: (route) => {
                return {
                  id: Number(route.params.id),
                };
              },
            },
            {
              path: 'projects-overview',
              name: 'ProjectsOverview',
              component: ProjectsOverview,
            },

            {
              path: 'jira-projects/:page?',
              name: 'ApplyJiraProjects',
              meta: { label: 'jira_projects_title' },
              props: true,
              component: ApplyJiraProjects
            },
            {
              path: 'jira-issues/:page?',
              name: 'ApplyJiraIssues',
              meta: { label: 'jira_issues_title' },
              props: true,
              component: ApplyJiraIssues
            },
            {
              path: 'jira-project/:project_key?/issues/:page?',
              name: 'ApplyJiraProjectIssues',
              meta: { label: 'Jira Issues' },
              props: true,
              component: ApplyJiraProjectIssues
            },

          ]
        },
      ]
    },
    {
      path: '/tv',
      name: 'LoginTv',
      component: LoginTv
    },
    {
      path: '/pages',
      redirect: '/pages/p404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view'); }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
});

// console.log('PermissionsDeclaration', PermissionsDeclaration);
function check(to, from, next) {
  // console.log(' to.fullPat', to, from);

  const tvCode = store.getters['Auth/tvCode'];
  // console.log(tvCode, to.fullPath, tvCode ? tvCode.url : tvCode);
  if (tvCode && !['/pages/login'].includes(to.path) && to.path !== tvCode.url) {
    // console.log('reddirect');
    next({ path: tvCode.url });
    return;// { path: tvCode.url };
  }

  if (!PermissionsDeclaration.routes[to.name]) {
    // All good, route is not protected
    next();
    return;
  }

  const routePermissions = PermissionsDeclaration.routes[to.name].permissions;
  if (!routePermissions || routePermissions.length === 0) {
    next();
    return;
  }
  // Check if user can view this page
  const userPermissions = store.getters['Auth/permissions'];
  if (!userPermissions || userPermissions.length === 0) {
    setTimeout(() => {
      check(to, from, next);
    }, 1000);
  } else {
    const userPermissionsMap = store.getters['Auth/permissionsMap'];
    // console.log("userPermissionsMap", userPermissionsMap);
    // console.log("routePermissions", routePermissions);
    for (let i = 0; i < routePermissions.length; i++) {
      if (userPermissionsMap[routePermissions[i]]) {
        next();
        return;
      }
    }
    console.log('You dont have permissions to view: ', to);
    console.log('permissions needed:', routePermissions);
    console.log('you have', userPermissions);
    next(false);
  }
}

router.beforeEach((to, from, next) => {
  // console.log('this', [to, from], to.meta.storeHist);
  // if (to.meta.storeHist) {
  //   console.log('asdasds', [to, from]);
  // }

  if (!publicRoutes.includes(to.name) && !store.getters['Auth/isLoggedIn']) {
    next({ name: 'Login' });
    return;
  }

  // console.log('this', [to, from]);
  check(to, from, next);
});

export default router;
